'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
function load(component) {
    return function () {
        return System.import('./components/' + components + '.vue');
    };
}
exports.default = new _vueRouter2.default({
    routes: [{
        path: '/',
        name: '首页',
        component: function component(resolve) {
            require(['./pages/index'], resolve);
        }

    }, {
        path: '/find',
        name: '发现',
        component: function component(resolve) {
            require(['./pages/find'], resolve);
        }

    }, {
        path: '/financial',
        name: '推荐',
        component: function component(resolve) {
            require(['./pages/financial'], resolve);
        }
    }]
});


// WEBPACK FOOTER //
// ./src/router.js